import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./components/ui/ScrollToTop";
import RouteTracker from "./components/Wrappers/RouteTracker";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RouteTracker />
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;